(function(){
  if(window.__lineaVariantCustomLoaded)return;
  window.__lineaVariantCustomLoaded=true;
  function lineaParseEU(text)
  {
    var match = text.trim().match(
      /^(\d{2})(?:(\.5)|(½)|\s*(1[.-]3|2[.-]3|⅓|⅔))?$/
    );

    if (!match) return null;

    var whole = Number(match[1]);

    if (whole < 16 || whole > 55) return null;

    var fraction = match[2] || match[3] ? 0.5 : 0;
    var symbol = fraction ? '½' : '';

    if (match[4])
    {
      fraction = /^(1|⅓)/.test(match[4]) ? 1 / 3 : 2 / 3;
      symbol = fraction === 1 / 3 ? '⅓' : '⅔';
    }

    return {
      key: whole + fraction,
      display: String(whole) + symbol
    };
  }

  function lineaParseSize(raw, brand)
  {
    var text = raw.trim();
    var eu;
    var second = null;
    var scale = '';

    var numeric = '(\\d{1,2}(?:\\.[05])?)';
    var match;

    if (brand === 'eu')
    {
      eu = lineaParseEU(text);
    }

    if (
      brand === 'salomon' ||
      brand === 'altra' ||
      brand === 'hoka'
    )
    {
      match = text.match(
        new RegExp(
          '^' +
          numeric +
          '\\s*\\(EU(?:R)?\\s+([^()]+)\\)$',
          'i'
        )
      );

      if (match)
      {
        eu = lineaParseEU(match[2]);
        second = match[1].replace(/\.0$/, '');

        scale = brand === 'salomon'
          ? 'UK'
          : 'USA';
      }

      else if (brand === 'hoka')
      {
        match = text.match(
          new RegExp(
            '^([^()]+)\\s*\\(' +
            numeric +
            '\\)$'
          )
        );

        if (match)
        {
          eu = lineaParseEU(match[1]);
          second = match[2].replace(/\.0$/, '');
          scale = 'USA';
        }
      }

      else if (
        brand === 'salomon' &&
        /^\d{2}$/.test(text)
      )
      {
        eu = lineaParseEU(text);
      }
    }

    return eu
      ? {
          key: eu.key,
          display: eu.display,
          secondary: second
            ? scale + ' ' + second
            : ''
        }
      : null;
  }

  function normalizeLineaSizes()
  {
    document
      .querySelectorAll(
        'fieldset[data-linea-size-brand]:not([data-linea-size-ready])'
      )
      .forEach(function(field)
      {
        var brand = field.dataset.lineaSizeBrand;
        var pairs = [];

        Array.from(field.children).forEach(function(input)
        {
          if (!input.matches('input[type="radio"]'))
            return;

          var label = input.nextElementSibling;

          if (
            !label ||
            label.tagName !== 'LABEL' ||
            label.htmlFor !== input.id
          )
            return;

          var display =
            label.querySelector('.linea-size-display');

          if (!display)
            return;

          var raw = display.dataset.lineaSizeRaw;

          var parsed =
            lineaParseSize(raw, brand);

          pairs.push({
            input: input,
            label: label,
            display: display,
            parsed: parsed,
            index: pairs.length,
            raw: raw
          });
        });

        field.dataset.lineaSizeReady = 'true';

        var ambiguous =
          pairs.filter(function(pair)
          {
            return !pair.parsed;
          });

        if (ambiguous.length)
        {
          field.dataset.lineaSizeAmbiguous =
            ambiguous.map(function(pair)
            {
              return pair.raw;
            }).join(' | ');

          console.warn(
            'Linea: taglie non interpretate; ordine originale mantenuto',
            field.dataset.lineaSizeAmbiguous
          );
        }

        pairs.forEach(function(pair)
        {
          if (!pair.parsed)
            return;

          pair.display.textContent = '';

          var primary =
            document.createElement('span');

          primary.className =
            'linea-size-eu';

          primary.textContent =
            pair.parsed.display;

          pair.display.appendChild(primary);

          if (pair.parsed.secondary)
          {
            var secondary =
              document.createElement('span');

            secondary.className =
              'linea-size-secondary';

            secondary.textContent =
              pair.parsed.secondary;

            pair.display.appendChild(secondary);
          }
        });

        if (!ambiguous.length)
        {
          pairs.sort(function(a, b)
          {
            return (
              a.parsed.key -
              b.parsed.key ||
              a.index -
              b.index
            );
          });

          var fragment =
            document.createDocumentFragment();

          pairs.forEach(function(pair)
          {
            fragment.appendChild(pair.input);
            fragment.appendChild(pair.label);
          });

          field.appendChild(fragment);
        }
      });
  }



  const lineaAvailabilityCache=new Map();
  function lineaApplySizeUnion(picker,allowed){
    if(!picker||!picker.isConnected)return;
    const field=picker.querySelector('fieldset.linea-shoe-sizes');
    if(!field)return;
    field.querySelectorAll('input[type="radio"]').forEach(function(input){
      const hide=!allowed.has(input.value);
      input.classList.toggle('linea-size-hidden',hide);
      if(input.nextElementSibling&&input.nextElementSibling.tagName==='LABEL'){
        input.nextElementSibling.classList.toggle('linea-size-hidden',hide);
      }
    });
    field.classList.remove('linea-size-loading');
    field.dataset.lineaSizeUnionChecked='true';
  }
  async function lineaGetColorSizeUnion(picker){
    const colors=Array.from(picker.querySelectorAll('fieldset.linea-color-options input[data-option-value-id]'))
      .filter(function(input){return input.dataset.lineaContextAvailable==='true';});
    const id=picker.dataset.section,productId=picker.dataset.productId,url=picker.dataset.lineaProductUrl;
    if(!colors.length||!id||!url||!productId)throw new Error('Impossibile identificare le opzioni disponibili');
    const allowed=new Set();
    let cursor=0;
    async function worker(){
      while(cursor<colors.length){
        const color=colors[cursor++];
        const endpoint=new URL(url,window.location.origin);
        endpoint.searchParams.set('section_id',id);
        endpoint.searchParams.set('option_values',color.dataset.optionValueId);
        endpoint.searchParams.delete('variant');
        const response=await fetch(endpoint.toString(),{credentials:'same-origin',headers:{'Accept':'text/html'}});
        if(!response.ok)throw new Error('Risposta Shopify '+response.status);
        const dom=new DOMParser().parseFromString(await response.text(),'text/html');
        const rendered=dom.querySelector('variant-selects[data-product-id="'+productId+'"]')||dom.querySelector('variant-selects');
        if(!rendered)throw new Error('Sezione Shopify priva di selettore taglie');
        const entries=rendered.querySelectorAll('fieldset.linea-shoe-sizes input[data-linea-context-available]');
        if(!entries.length)throw new Error('Non è disponibile il dettaglio delle taglie');
        entries.forEach(function(input){
          if(input.dataset.lineaContextAvailable==='true')allowed.add(input.value);
        });
      }
    }
    await Promise.all(Array.from({length:Math.min(4,colors.length)},worker));
    return allowed;
  }
  function lineaInitHighVariantSizes(){
    document.querySelectorAll('variant-selects[data-linea-high-variants="true"]').forEach(function(picker){
      const field=picker.querySelector('fieldset.linea-shoe-sizes');
      if(!field)return;
      const key=picker.dataset.productId;
      let stored=lineaAvailabilityCache.get(key);
      if(stored&&stored.available){
        lineaApplySizeUnion(picker,stored.available);
        return;
      }
      field.classList.add('linea-size-loading');
      if(!stored){
        stored={promise:null,available:null};
        lineaAvailabilityCache.set(key,stored);
        stored.promise=lineaGetColorSizeUnion(picker).then(function(available){
          stored.available=available;
          document.querySelectorAll('variant-selects[data-linea-high-variants="true"][data-product-id="'+key+'"]').forEach(function(current){
            lineaApplySizeUnion(current,available);
          });
        }).catch(function(error){
          console.warn('Linea: verifica taglie non completata, nessuna taglia nascosta.',error);
          lineaAvailabilityCache.delete(key);
          document.querySelectorAll('variant-selects[data-linea-high-variants="true"][data-product-id="'+key+'"] fieldset.linea-shoe-sizes').forEach(function(current){
            current.classList.remove('linea-size-loading');
          });
        });
      }
    });
  }
  function init(){normalizeLineaSizes();lineaInitHighVariantSizes();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  new MutationObserver(function(mutations){
    if(mutations.some(function(m){return Array.from(m.addedNodes).some(function(n){return n.nodeType===1&&n.matches&&(n.matches('variant-selects,fieldset.linea-shoe-sizes')||n.querySelector('fieldset.linea-shoe-sizes'));});}))init();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
